// extracted by mini-css-extract-plugin
export var container = "LoadingSpinner-module--container--5407d";
export var overlay = "LoadingSpinner-module--overlay--a18ba";
export var spin = "LoadingSpinner-module--spin--8c69c";
export var spinner = "LoadingSpinner-module--spinner--f8db3";